import React from "react";
import type {FunctionComponent} from "react";
import s from "../../styles/common/dynamicImage.module.scss";

export interface IDynamicImageProps extends React.DetailedHTMLProps<React.ImgHTMLAttributes<HTMLImageElement>, HTMLImageElement>{
  pngSrc: string;
  webpSrc: string;
  additionalClassName?: string;
  isHeightConstrained?: boolean; // Reduces the width to fit the parent's height.
}

/**
 * Image with dynamic sizing.
 */
export const DynamicImage: FunctionComponent<IDynamicImageProps> = ({
  pngSrc,
  webpSrc,
  alt,
  additionalClassName,
  isHeightConstrained = "true",
  ...props
}) => {
  const useClassNames: string[] = [s.dynamicImage];
  if (additionalClassName) {
    useClassNames.push(`${additionalClassName}`);
  }

  const imgClass = (isHeightConstrained) ? s.constrainHeight : ``;

  return (
    <picture className={useClassNames.join(` `)}>
      <source srcSet={webpSrc} type={"image/webp"} />
      <img src={pngSrc} alt={alt} {...props} className={imgClass} />
    </picture>
  );
}
